import type { TFunction } from 'i18next'

import { CURRICULUM_BASKET_TYPES } from '../constants/curriculum-basket-type'

export const getCurriculumBasketTypeOptions = (
  t: TFunction<'curriculumsManagement'>
) =>
  CURRICULUM_BASKET_TYPES.map(type => ({
    label: t(`basket-type.${type}`),
    value: type
  }))
